import { createSelector } from '@reduxjs/toolkit';

import { ArtworksState } from '@definitions/artworks.types';

import { GlobalState } from '../createStore';

export const selectTradeArtworksDomain = (state: GlobalState) => state.tradeArtworks;

export const selectGridSize = createSelector(selectTradeArtworksDomain, (state: ArtworksState) => state.gridSize);
export const selectArtworks = createSelector(selectTradeArtworksDomain, (state: ArtworksState) => state.artworks);
export const selectLoading = createSelector(selectTradeArtworksDomain, (state: ArtworksState) => state.loading);
export const selectCurrentPage = createSelector(selectTradeArtworksDomain, (state: ArtworksState) => state.currentPage);
export const selectFavoriteArtworks = createSelector(
  selectTradeArtworksDomain,
  (state: ArtworksState) => state.favoriteArtworks
);
export const selectMeta = createSelector(selectTradeArtworksDomain, (state: ArtworksState) => state.meta);
export const selectArtworkDynamicData = createSelector(
  selectTradeArtworksDomain,
  (state: ArtworksState) => state.artworkDynamicData
);
